<template>
  <div class="pitemrow26">
    <div class="pitemrow26-item">
      <div class="content">
        <p class="title1">LIMS系统</p>
        <p class="title2">面向各类实验室提供一体化信息化解决方案。符合17025体系，覆盖样品全生命周期与检测业务流程，统一管理实验室人、机、料、法、环，实现委托、检测任务、原始数据录入和采集、报告编制及签审实验室检测业务数字化闭环，保障数据完整可追溯，助力实验室实现合规化、数字化管理。</p>
        <ul>
          <li>
            <div class="btn-tag">
            <div class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
              <path d="M0 0h32v32H0z" fill="none" />
              <path fill="currentColor" d="M20 10h-8V8h8zm-4 18H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v17h2V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v4H2v2h2v5H2v2h2v5H2v2h2v4c0 1.1.9 2 2 2h10zm4-13h-8v2h8zm3 12.2l-2.6-2.6L19 26l4 4l7-7l-1.4-1.4z" />
            </svg>
          </div><div>标准管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="currentColor" d="M7 19.583v-6.737h2.08q.137 0 .284.028q.145.028.282.078l6.021 2.21q.447.163.736.536q.29.373.29.839q0 .275-.18.446t-.444.17h-1.202q-.51 0-.995-.06t-.95-.226l-1.793-.644l-.287.744l1.964.675q.473.16.977.22q.504.061 1.02.061h5.159q.684 0 1.169.45t.485 1.127l-6.995 2.308zM3 21v-8.154h3V21zm10.54-9.95l-3.538-3.539l.714-.688l2.825 2.825l5.675-5.65l.688.688z" />
          </svg>
          </div><div>委托管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 48 48">
            <path d="M0 0h48v48H0z" fill="none" />
            <path fill="currentColor" fill-rule="evenodd" d="M6.879 6.879A3 3 0 0 0 6 9v5h2.138q0 .066.004.133l1.734 26A2 2 0 0 0 11.87 42h23.26a2 2 0 0 0 1.995-1.867l1.734-26a2 2 0 0 0 .004-.133H42V9a2.99 2.99 0 0 0-1.832-2.764A3 3 0 0 0 39 6H9a3 3 0 0 0-2.121.879M36.862 14H10.138l.267 4H21a2 2 0 0 1 2 2v2h13.329zm-25.748 6l.778 14H21V20zM11 11.714H9V8.286h2zm4-3.428h-2v3.428h2zm4 3.428h-2V8.286h2zm4-3.428h-2v3.428h2zm4 3.428h-2V8.286h2zm4-3.428h-2v3.428h2zm4 3.428h-2V8.286h2zm4-3.428h-2v3.428h2z" clip-rule="evenodd" />
          </svg>

          </div><div>样品管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="currentColor" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M4 19V5h16v14z" />
            <path fill="currentColor" d="M13 8h5v2h-5zm-5 .59L6.96 7.54L5.54 8.96L8 11.41l3.46-3.45l-1.42-1.42zM13 14h5v2h-5zm-5 .59l-1.04-1.05l-1.42 1.42L8 17.41l3.46-3.45l-1.42-1.42z" />
          </svg>
          </div><div>任务管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 2048 2048">
            <path d="M0 0h2048v2048H0z" fill="none" />
            <path fill="currentColor" d="M1280 896H256V256h1024zm-128-512H384v384h768zm896 256v1024H896v-128h1024V768h-384v384H768v256l-128-128v-128H0V0h1536v640zm-640-512H128v896h1280zM464 1414l315 314l-319 318l-74-74l179-180H384q-80 0-149-30t-122-82t-83-122t-30-150h128q0 53 20 99t55 82t81 55t100 20h181l-175-176z" />
          </svg>
          </div><div>原始数据</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="currentColor" d="m19.94 7.68l-.03-.09a.8.8 0 0 0-.2-.29l-5-5a1 1 0 0 0-.3-.2l-.09-.03a.9.9 0 0 0-.27-.05c-.02 0-.04-.01-.05-.01H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-12s-.01-.04-.01-.06c0-.09-.02-.17-.05-.26ZM6 20V4h7v4c0 .55.45 1 1 1h4v11z" />
            <path fill="currentColor" d="M8 12h2v6H8zm3-2h2v8h-2zm3 4h2v4h-2z" />
          </svg>
          </div><div>报告管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M3.5 19.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0m12 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0" />
              <path d="M4.454 17.535L2.5 10.5h19l-1.954 7.035M8.5 19.5h7M4.5 8V6l3-2l3 1.5l4-3l5 3.5v2" />
            </g>
          </svg>
          </div><div>资源管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 48 48">
            <path d="M0 0h48v48H0z" fill="none" />
            <circle cx="16" cy="18" r=".75" fill="currentColor" />
            <circle cx="14" cy="21" r=".75" fill="currentColor" />
            <circle cx="18" cy="18" r=".75" fill="currentColor" />
            <circle cx="20" cy="18" r=".75" fill="currentColor" />
            <circle cx="16" cy="30" r=".75" fill="currentColor" />
            <circle cx="18" cy="30" r=".75" fill="currentColor" />
            <circle cx="20" cy="30" r=".75" fill="currentColor" />
            <circle cx="26" cy="30" r=".75" fill="currentColor" />
            <circle cx="28" cy="30" r=".75" fill="currentColor" />
            <circle cx="30" cy="30" r=".75" fill="currentColor" />
            <circle cx="32" cy="30" r=".75" fill="currentColor" />
            <circle cx="22" cy="21" r=".75" fill="currentColor" />
            <circle cx="26" cy="21" r=".75" fill="currentColor" />
            <circle cx="14" cy="24" r=".75" fill="currentColor" />
            <circle cx="22" cy="24" r=".75" fill="currentColor" />
            <circle cx="14" cy="27" r=".75" fill="currentColor" />
            <circle cx="22" cy="27" r=".75" fill="currentColor" />
            <circle cx="34" cy="27" r=".75" fill="currentColor" />
            <circle cx="28" cy="24" r=".75" fill="currentColor" />
            <circle cx="30" cy="24" r=".75" fill="currentColor" />
            <circle cx="32" cy="24" r=".75" fill="currentColor" />
            <circle cx="28" cy="18" r=".75" fill="currentColor" />
            <circle cx="30" cy="18" r=".75" fill="currentColor" />
            <circle cx="32" cy="18" r=".75" fill="currentColor" />
            <circle cx="34" cy="18" r=".75" fill="currentColor" />
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M39.23 26q.13-.995.14-2a17 17 0 0 0-.14-2l4.33-3.39a1 1 0 0 0 .25-1.31l-4.1-7.11a1 1 0 0 0-1.25-.44l-5.11 2.06a15.7 15.7 0 0 0-3.46-2l-.77-5.43a1 1 0 0 0-1-.86H19.9a1 1 0 0 0-1 .86l-.77 5.43a15.4 15.4 0 0 0-3.46 2L9.54 9.75a1 1 0 0 0-1.25.44l-4.1 7.11a1 1 0 0 0 .25 1.31L8.76 22a17 17 0 0 0-.14 2q.01 1.005.14 2l-4.32 3.39a1 1 0 0 0-.25 1.31l4.1 7.11a1 1 0 0 0 1.25.44l5.11-2.06a15.7 15.7 0 0 0 3.46 2l.77 5.43a1 1 0 0 0 1 .86h8.2a1 1 0 0 0 1-.86l.77-5.43a15.4 15.4 0 0 0 3.46-2l5.11 2.06a1 1 0 0 0 1.25-.44l4.1-7.11a1 1 0 0 0-.25-1.31z" />
          </svg>
          </div><div>体系管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path d="M0 0h32v32H0z" fill="none" />
            <path fill="currentColor" d="m30 28.6l-2.8-2.8c.5-.8.8-1.8.8-2.8c0-2.8-2.2-5-5-5s-5 2.2-5 5s2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3s-1.3 3-3 3s-3-1.3-3-3M8 16h10v2H8zm0-6h12v2H8z" />
            <path fill="currentColor" d="m14 27.7l-5.2-2.8C5.8 23.4 4 20.3 4 17V4h20v11h2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13c0 4.1 2.2 7.8 5.8 9.7L14 30z" />
          </svg>
          </div><div>质控管理</div></div></li>
          <li><div class="btn-tag"><div class="btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="currentColor" d="M21 21H3v-2h18zM8 10H4v7h4zm6-4h-4v11h4zm6-3h-4v14h4z" />
          </svg>
          </div><div>统计分析</div></div></li>
        </ul>
        <router-link :to="'/products/28'">
          <el-button type="primary" style="margin-top:1.5rem" @click="openConsultBox">免费试用</el-button>
        </router-link>
      </div>
      <div class="imgright">
        <img :src="aimg" alt="" style="object-fit: contain; width: 100%; height: 100%;">
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from './TitleBar.vue'

import arrow from '../assets/arrow-right.png'
import a from '../assets/软件产品-28.jpg'
import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'
import axios from "axios"

export default {
  name: 'PItemRow28',
  data() {
    return {
      msg:{
        title: '',
        subTitle: ''
      },
      aimg:a,
      arrow: arrow,
      item3:''
    }
  },
  components: {
    TitleBar
  },
  methods: {
    openConsultBox(){
      window.$crisp.push(['do', 'chat:open']);
    },
  },
  created: function(){
    
      
  },
  watch: {
    '$route': function(to, from) {
      const id = this.$store.state.currentLanguage.id
      
    }
  }
}
</script>

<style lang="scss">
.pitemrow26 {
  max-width: 1440px;
  margin: 2rem auto;
  margin-bottom: 5rem;
  .pitemrow26-item{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    max-width: 1440px;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .content{
    width: 20.6rem;
    margin-top: 5rem;
    .title1{
      font-size: 1.6rem;
      margin-bottom: 1rem;
      font-weight: 600;
    }
    .title2{
      font-size: 0.8rem;
      margin-bottom: 2.5rem;
      color:#666666;
      line-height: 1.7;
    }
    ul{
      width: 22rem;
      li{
        display: inline-block;
        text-align: center;
        margin-right: 0.8rem;
        margin-bottom:1rem;
        font-size: 0.7rem;
        width: 3.5rem;
        .management-icon{
          display: inline-block;
          width: 38px;
          height: 38px;
          background-image: url(../assets/projecticons.png);
          background-size: 500%;
          background-position:0 0;
          border: 0;
          margin-bottom: 0.5rem;
        }
      }
    }
  }
  .imgright{
    margin-top: 2rem;
  }
}
.btn-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}
.btn-icon {
  width: 36px;
  height: 36px;
  color: deepskyblue;
}
</style>